import { useEffect, useRef, type RefObject } from 'react';
import { trapTab } from '@platform/ui/focusTrap';

/**
 * Клавіатура модальної панелі (UIUX patterns/keyboard): Esc закриває (на фазі перехоплення, тож панель розширених фільтрів під нею
 * лишається відкритою), Tab не виходить за межі панелі; після закриття фокус повертається туди, де був до відкриття.
 */
export function useDrawerKeys(root: RefObject<HTMLElement | null>, onClose: () => void): void {
  const close = useRef(onClose);
  useEffect(() => { close.current = onClose; }, [onClose]);
  useEffect(() => {
    const previous = document.activeElement as HTMLElement | null;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close.current(); } else if (root.current) trapTab(root.current, e);
    };
    window.addEventListener('keydown', onKey, true);
    return () => { window.removeEventListener('keydown', onKey, true); previous?.focus?.(); };
  }, [root]);
}
